import React from 'react';
import classNames from 'classnames';

import RadioButton from 'components/RadioButton';
import {ErrorField} from 'components/Fields';

class RadioField extends React.Component<any> {
  render() {
    const {
      input: {onChange},
      className,
      disabled,
      checked,
      optionValue,
      meta: {touched, error}
    } = this.props;

    return (
      <div
        className={classNames('RadioField', className, {
          error: touched && error
        })}>
        <RadioButton
          name={name}
          value={optionValue}
          checked={checked}
          onChange={onChange}
          disabled={disabled}
        />
        <ErrorField touched={touched} error={error} />
      </div>
    );
  }
}

export default RadioField;
